var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup48096207(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 48096207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2701 17.4199C25.6831 13.8888 24.0485 10.2782 20.802 8.3303C20.5308 8.16757 20.2546 8.02022 19.9745 7.88802L17.8547 15.2987L25.2701 17.4199ZM24.4439 20.3039L16.5489 18.0455L16.5057 18.0332C16.3207 17.9805 16.0598 17.9062 15.838 17.8092C15.5583 17.6869 15.143 17.4484 14.8696 16.9559C14.5961 16.4633 14.6134 15.9847 14.6574 15.6827C14.6924 15.4431 14.7673 15.1824 14.8204 14.9976L14.8328 14.9544L17.0904 7.06221C13.5597 6.64972 9.94962 8.28431 8.00198 11.5305C5.35106 15.9488 6.78382 21.6795 11.2021 24.3305C15.6205 26.9814 21.3512 25.5486 24.0021 21.1303C24.1647 20.8594 24.3118 20.5836 24.4439 20.3039Z",
    fill: "#4E0AA5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 52",
    d: "M25.2894 18.9905C26.2193 19.2566 26.6843 19.3896 27.0704 19.1297C27.4564 18.8698 27.5027 18.4399 27.5951 17.58C27.6869 16.7262 27.6843 15.8629 27.5861 15.0057C27.4118 13.4842 26.9394 12.0119 26.1961 10.6729C25.4528 9.33397 24.453 8.15452 23.2538 7.20193C22.5783 6.66526 21.8469 6.20651 21.0737 5.83292C20.295 5.45669 19.9057 5.26858 19.481 5.45878C19.0562 5.64899 18.9232 6.11398 18.6572 7.04397L16.55 14.4105C16.2907 15.3169 16.1611 15.7701 16.3621 16.1323C16.5632 16.4944 17.0164 16.6241 17.9229 16.8834L25.2894 18.9905Z",
    fill: "#4E0AA5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup48096207);
export default __webpack_public_path__ + "static/media/Group_48096207.aba9afbd3def3f87f15ce0309cfc6612.svg";
export { ForwardRef as ReactComponent };